export enum AmortizationScheduleMode {
    DoNotOfferToClients = 0,
    OfferToClientsAsAnOption = 1,
    ForcedToAllClients = 2
}